// =============================================================================
// OWNER BADGE — initials + hash color for the owner_at_send bubble badge
// =============================================================================
// Renders "who owned the lead when this message was sent" on outbound DM
// bubbles (fired-setter ownership work — STEP 0). Same initials/hash-color
// pattern as components/instagram/MessageBubble.tsx so the two DM surfaces
// read identically. Full name in → 2-letter initials + a stable per-name color.
// =============================================================================

/** First+last initial when the name has two words, else the first two letters. */
export function getOwnerInitials(name: string | null | undefined): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
}

// Hash the name to a stable color so Alice vs Alyssa (same "A…" initials) still
// read apart at a glance. The hover-name (Tooltip) is the exact disambiguator.
const OWNER_COLORS = [
  "bg-blue-500",
  "bg-purple-500",
  "bg-pink-500",
  "bg-emerald-500",
  "bg-indigo-500",
  "bg-cyan-500",
  "bg-orange-500",
  "bg-teal-500",
];

export function getOwnerColor(name: string | null | undefined): string {
  if (!name) return "bg-black/[0.06]"; // unknown owner — muted glass, light-mode safe
  const hash = name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return OWNER_COLORS[hash % OWNER_COLORS.length];
}
